import { Link } from 'react-router-dom';
import { isNativeApp } from '../api/axios';
import { useAppMode, useDeviceDrafts } from '../offline/useOffline';

export default function OfflineBanner() {
  const { mode, disconnected } = useAppMode();
  const drafts = useDeviceDrafts();
  const pending = drafts.length;
  const offlineMode = mode === 'offline';

  if (!offlineMode && !disconnected && !pending) return null;

  let message = '';
  if (offlineMode) {
    message = 'الوضع أوفلاين: الفحوصات الجديدة تُحفظ على هذا الجهاز، ولا تُعرض فحوصات الخادم. للمزامنة اختر «أونلاين».';
  } else if (disconnected) {
    message = isNativeApp()
      ? 'لا يوجد اتصال بالخادم. لإضافة فحوصات على الجهاز اختر الوضع «أوفلاين».'
      : 'لا يوجد اتصال بالخادم.';
  }

  return (
    <div className={`border-b px-4 py-2 text-sm ${offlineMode || disconnected ? 'bg-amber-50 border-amber-200 text-amber-900' : 'bg-blue-50 border-blue-200 text-blue-900'}`}>
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-2">
        <span>
          {message}
          {pending > 0 && ` على الجهاز ${pending} ${pending === 1 ? 'فحص لم يُرفع' : 'فحوصات لم تُرفع'}.`}
        </span>
        {pending > 0 && (
          <Link to="/sync" className="rounded-lg border border-current px-3 py-1 font-semibold">
            فحوصات الجهاز والمزامنة
          </Link>
        )}
      </div>
    </div>
  );
}
